import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cn } from "@/app/utils/tw-merge";

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    data-slot="label"
    className={cn(
      "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
      className
    )}
    {...props}
  />
));
Label.displayName = LabelPrimitive.Root.displayName;

function RequiredMark({ className }: { className?: string }) {
  return <span aria-hidden="true" className={cn("ml-0.5 text-destructive before:content-['*']", className)} />;
}

const RequiredLabel = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ children, ...props }, ref) => (
  <Label ref={ref} {...props}>
    {children}
    <RequiredMark />
  </Label>
));
RequiredLabel.displayName = "RequiredLabel";

export { Label, RequiredLabel, RequiredMark };
